import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import {
  Grid, Tooltip, TextField, Button, FormLabel
} from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { makeStyles } from '@material-ui/core';

import { editPassword } from '../../actions/employee.action';
import { addAlert } from '../../actions/alerts.action';

const Password = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [ password, setPassword ] = useState('');
  const [ passwordSecondTime, setPasswordSecondTime ] = useState('');
  const [ currentPassword, setCurrentPassword ] = useState('');

  const handleOnSavePassword = () => {
    if (!currentPassword)  return errorMessage(t('common.alert.missing_current_password'));
    if (password !== passwordSecondTime) return errorMessage(t('common.alert.passwords_missmatch'));
    dispatch(editPassword({ password, currentPassword }, resetState));
  };

  const resetState = () => {
    setPassword('');
    setPasswordSecondTime('');
    setCurrentPassword('');
  };

  const errorMessage = error => {
    return dispatch(addAlert({ message: error, severity: 'error' }));
  };

  const handleOnChangeCurrentPassword = event => setCurrentPassword(event.target.value);
  const handleOnChangePassword = event => setPassword(event.target.value);
  const handleOnChangePasswordAgain = event => setPasswordSecondTime(event.target.value);

  const useStyles = makeStyles({
    helpIcon: {
      color: '#969696'
    },
    saveBtn: {
      marginTop: '10px'
    },
    label: {
      color: '#999999',
      fontSize: '16px',
      textTransform: 'uppercase'
    },
    icon: {
      margin: '-3px auto auto 10px'
    }
  });

  const classes = useStyles();

  return (
    <>
      <Grid item className='password-form'>
        <Grid container direction="row">
          <FormLabel className={ classes.label }>
            { t('settings.password.title') }
          </FormLabel>
          <div className={ classes.icon }>
            <Tooltip title={ t('settings.password.password.helperText') }>
              <HelpOutlineIcon fontSize='small' className={ classes.helpIcon }/>
            </Tooltip>
          </div>
        </Grid>
        <TextField
          fullWidth
          value={ currentPassword }
          type="password"
          label={ t('settings.password.currentPassword.label') }
          onChange={ handleOnChangeCurrentPassword }
        />
        <TextField
          fullWidth
          value={ password }
          type="password"
          label={ t('settings.password.password.label') }
          onChange={ handleOnChangePassword }
        />
        <TextField
          fullWidth
          value={ passwordSecondTime }
          type="password"
          label={ t('settings.password.passwordAgain.label') }
          onChange={ handleOnChangePasswordAgain }
        />
        <Grid container justifyContent="flex-end">
          <Button
            onClick={ handleOnSavePassword }
            color="primary"
            variant="contained"
            disabled={ !password || !passwordSecondTime || !currentPassword }
            className={ classes.saveBtn }
          >
            <div>{ t('settings.password.save') }</div>
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default Password;
